import React from 'react';

function Brand({ compact = false }) {
  return (
    <div className="flex shrink-0 items-center">
      {compact ? (
        <img src="/brand/silatrail-icon-192.png" alt="SilaTrail" width="40" height="40" className="h-10 w-10 rounded-lg" />
      ) : (
        <img src="/brand/silatrail-logo.png" alt="SilaTrail" width="168" height="51" className="h-auto w-[168px] max-w-full" />
      )}
    </div>
  );
}

export default Brand;
